import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import { space, SpaceProps } from 'styled-system';

export const StyledTableWrapper = styled.div<SpaceProps>`
  position: relative;
  border: 1px solid #d5d9e7;
  overflow: hidden;
  border-radius: ${themeGet('radii.small')};

  ${space}
`;

export const StyledEmpty = styled.div<SpaceProps>`
  display: flex;
  justify-content: center;
  padding: 48px 40px;
  background-color: ${themeGet('colors.body.bg')};
  box-shadow: ${themeGet('shadows.section')};
  border-radius: ${themeGet('radii.base')};

  ${space}

  p {
    color: ${themeGet('colors.text.regular')};
    font-size: ${themeGet('fontSizes.base')}px;
    font-weight: ${themeGet('fontWeights.semiBold')};
  }
`;

export const StyledTableTitle = styled.h6`
  line-height: 24px;
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledTableHead = styled.div`
  padding: 16px 16px 6px 16px;
`;

export const StyledTableCell = styled.div`
  line-height: 24px;
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};
`;

export const StyledTableRow = styled.div`
  display: grid;
  grid-gap: 16px;
  padding: 0;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  &.mode-default.is--checked,
  &.mode-input.is--checked {
    ${StyledTableCell} {
      color: ${themeGet('colors.primary.regular')};
    }
  }

  &.mode {
    &-default {
      grid-template-columns: 1.2fr 2fr 24px;
    }
    &-input {
      grid-template-columns: 1.5fr 1.3fr 2fr 24px;
    }
    &-selected {
      grid-template-columns: 1.4fr 1.3fr 2.3fr;
    }
  }
`;

export const StyledTableBody = styled.div`
  padding: 0 5px 16px 16px;
`;

export const StyledTableRows = styled.div`
  overflow: scroll;
  max-height: 178px;
  padding-right: 10px;
`;

export const StyledInput = styled.div`
  position: relative;

  .custom-tooltip {
    position: absolute;
    top: 4px;
    right: 14px;
    color: ${themeGet('colors.input.textError')};
  }
`;
